import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import WhyNaavi from "./pages/WhyNaavi";
import CurriculumPage from "./pages/CurriculumPage";
import ProgramsPage from "./pages/ProgramsPage";
import AdmissionsPage from "./pages/AdmissionsPage";
import FAQ from "./pages/FAQ";
import Gallery from "./pages/Gallery";
import AdminLogin from "./pages/AdminLogin";
import AdminForgotPassword from "./pages/AdminForgotPassword";
import AdminResetPassword from "./pages/AdminResetPassword";
import AdminDashboard from "./pages/AdminDashboard";
import ParentLogin from "./pages/ParentLogin";
import ParentPortal from "./pages/ParentPortal";
import PaymentStatus from "./pages/PaymentStatus";
import StaffClock from "./pages/StaffClock";
import WhatsAppButton from "./components/WhatsAppButton";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/why-naavi" element={<WhyNaavi />} />
          <Route path="/curriculum" element={<CurriculumPage />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/admissions" element={<AdmissionsPage />} />
          <Route path="/faqs" element={<FAQ />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/students/:studentId" element={<AdminDashboard />} />
          <Route path="/parent/login" element={<ParentLogin />} />
          <Route path="/parent" element={<ParentPortal />} />
          <Route path="/payment-status" element={<PaymentStatus />} />
          <Route path="/staff/clock" element={<StaffClock />} />
        </Routes>
        <WhatsAppButton />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
